import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form", "notes", "content", "submit"];

  connect() {
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.handleFocusIn = this.handleFocusIn.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);
    this.element.addEventListener("trix-focus", this.scrollToBottom);
    this.element.addEventListener("trix-blur", this.scrollToBottom);
    this.element.addEventListener("focusin", this.handleFocusIn);
    this.element.addEventListener("focusout", this.handleFocusOut);
  }

  disconnect() {
    this.element.removeEventListener("trix-focus", this.scrollToBottom);
    this.element.removeEventListener("trix-blur", this.scrollToBottom);
    this.element.removeEventListener("focusin", this.handleFocusIn);
    this.element.removeEventListener("focusout", this.handleFocusOut);
  }

  handleFocusIn(event) {
    if (event.target.tagName === "TRIX-EDITOR" || event.target.matches("textarea, input[type='text']")) {
      this.scrollToBottom();
    }
  }

  handleFocusOut(event) {
    if (event.target.tagName === "TRIX-EDITOR" || event.target.matches("textarea, input[type='text']")) {
      this.scrollToBottom();
    }
  }

  scrollToBottom() {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });
  }

  submit(event) {
    event.preventDefault();

    if (this.isEmpty()) {
      window.notyf && window.notyf.error("Please enter a message before sending.");
      return;
    }

    const formData = new FormData(this.formTarget);
    const url = this.formTarget.getAttribute("action");

    this.setSubmitting(true);

    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": localStorage.getItem("bp-x-csrf-token"),
        "X-Requested-With": "XMLHttpRequest",
      },
      credentials: "same-origin",
      body: formData,
    })
      .then((response) =>
        response
          .json()
          .catch(() => ({}))
          .then((data) => ({ ok: response.ok, data }))
      )
      .then(({ ok, data }) => {
        if (ok && data.html) {
          this.appendNote(data.html);
          this.resetEditor();
        } else {
          const message = (data && data.error) || "Unable to save message.";
          window.notyf && window.notyf.error(message);
        }
      })
      .catch(() => {
        window.notyf && window.notyf.error("Something went wrong. Please try again.");
      })
      .finally(() => {
        this.setSubmitting(false);
      });
  }

  isEmpty() {
    if (!this.hasContentTarget) return false;
    const trixInput = this.contentTarget;
    const trixEditor = this.formTarget.querySelector(`trix-editor[input="${trixInput.id}"]`);
    const value = trixEditor ? trixEditor.innerText.trim() : (trixInput.value || "").trim();
    return value === "";
  }

  appendNote(html) {
    if (this.notesTarget.children.length > 0) {
      const hr = document.createElement("hr");
      hr.className = "my-4";
      this.notesTarget.appendChild(hr);
    }

    const wrapper = document.createElement("div");
    wrapper.innerHTML = html.trim();
    Array.from(wrapper.children).forEach((node) => {
      this.notesTarget.appendChild(node);
    });
  }

  resetEditor() {
    if (!this.hasContentTarget) return;
    const trixInput = this.contentTarget;
    const trixEditor = this.formTarget.querySelector(`trix-editor[input="${trixInput.id}"]`);
    if (trixEditor && trixEditor.editor) {
      trixEditor.editor.loadHTML("");
    } else {
      trixInput.value = "";
    }
  }

  setSubmitting(isSubmitting) {
    if (!this.hasSubmitTarget) return;
    const btn = this.submitTarget;
    if (isSubmitting) {
      btn.dataset.originalHtml = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i> Sending...';
    } else {
      btn.disabled = false;
      if (btn.dataset.originalHtml) {
        btn.innerHTML = btn.dataset.originalHtml;
        delete btn.dataset.originalHtml;
      }
    }
  }
}
